import React from 'react';
import { RotateSpinner } from 'react-spinners-kit';

const LoadingSpiner = (): JSX.Element => {
    return <RotateSpinner loading={true} color="#3c4b64" />;
};

export default LoadingSpiner;
